var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 27 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "18.5335028%",
    y1: "12.7025463%",
    x2: "85.5957031%",
    y2: "72.728588%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web/Folder-Sort-(Desktop)",
    transform: "translate(-658.000000, -14.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(658.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5000488,21.5547817 C10.580351,21.5547817 8.11390146,23.1722785 8.11390146,25.0868113 C8.11390146,25.9364015 8.60022795,26.7270625 9.39541502,27.3442605 C10.297828,26.3720785 11.8007099,25.7337453 13.5000488,25.7337453 C15.1992901,25.7337453 16.702172,26.3719642 17.6045459,27.3441557 C18.3997525,26.7270625 18.8860595,25.9364015 18.8860595,25.0868113 C18.8860595,23.1722785 16.4195513,21.5547817 13.5000488,21.5547817 L13.5000488,21.5547817 Z M13.5000488,0 C6.04414667,0 0,5.74565586 0,12.8331458 C0,17.5152781 2.63876714,21.6102152 6.57862516,23.8514629 C7.33741248,21.5639254 10.1518773,19.8601542 13.5000488,19.8601542 C16.848025,19.8601542 19.6625094,21.5640206 20.4212772,23.8514629 C24.3612622,21.6102152 27,17.5152781 27,12.8331458 C27,5.74565586 20.9558436,0 13.5000488,0 L13.5000488,0 Z M13.5000488,26.9328809 C11.424794,26.9328809 9.73645511,28.0693633 9.73645511,29.4664405 C9.73645511,30.8635176 11.424794,32 13.5000488,32 C15.5754013,32 17.2636035,30.8635176 17.2636035,29.4664405 C17.2636035,28.0693633 15.5754013,26.9328809 13.5000488,26.9328809",
    id: "Combined-Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.42b29a00.svg";
export { ForwardRef as ReactComponent };